module.exports = __webpack_public_path__ + "static/media/services-img.7ae43e91.jpg";